import { v4 as uuidv4 } from "uuid";

import { TransactionTypeDTO } from "../../models/transaction-types";
import { TransactionDTO } from "../../models/transactions";
import { AssetTypeRef } from "../../models/asset-types";
import { ClientInvoiceRef } from "../../models/legal-entity-clients/client-invoices";
import { VendorInvoiceRef } from "../../models/legal-entity-vendors/vendor-invoices";

import { TRANSACTION_STATUS_TYPES, TRANSACTION_TYPES } from "../../utils/constants/constants";

export const clientInvoice: ClientInvoiceRef = {
  id: uuidv4(),
  companyAccount: null,
  isDeleted: false,
  client: null,
  invoiceNumber: "",
  totalAmount: 0,
  comment: "",
  vatNumber: "",
  currency: null,
  issueDate: new Date(),
  dueDate: new Date(),
  vatCountry: null,
  vatBases: [],
  sentToClientOn: null,
  sentToAccountingOn: null,
  paidOn: null,
};

export const vendorInvoice: VendorInvoiceRef = {
  id: uuidv4(),
  companyAccount: null,
  isDeleted: false,
  vendor: null,
  invoiceNumber: "",
  totalAmount: 0,
  comment: "",
  vatNumber: "",
  currency: null,
  issueDate: new Date(),
  dueDate: new Date(),
  vatCountry: null,
  vatBases: [],
  receivedFromVendorOn: null,
  sentToAccountingOn: null,
  paidOn: null,
};

export const defaultTransaction: TransactionDTO = {
  id: "",
  companyAccount: null,
  isDeleted: false,
  createdAt: new Date(0, 0, 1),
  createdByUser: null,
  comment: "",
  transactionDate: {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  },
  amount: 0,
  bookedAmount: 0,
  currency: null,
  type: null,
  status: {
    isDeleted: false,
    ...TRANSACTION_STATUS_TYPES.PENDING,
  },
  legalEntity: null,
  legislation: null,
  clarifications: [],
  transactionDocuments: [],
  dynamicFields: [],
  assets: [],
  client: null,
  clientInvoice: null,
  vendor: null,
  vendorInvoice: null,
  fromWhichBankAccount: null,
  toWhichBankAccount: null,
  fromWhichCashAccount: null,
  toWhichCashAccount: null,
  expenses: [],
  revenues: [],
  attributionsOfTheReceivedDonation: [],
  loans: [],
  donatorMember: null,
  donationBeneficiary: null,
  usagesOfDonationFunds: [],
};

interface Asset {
  name: string;
  type: AssetTypeRef | null;
  amount: number;
}

export const assetsList: Asset[] = [
  {
    name: "",
    type: null,
    amount: 0,
  },
];

export const setFieldByTransactionType = (transactionType: TransactionTypeDTO) => {
  if (!transactionType) return;

  return {
    ...(transactionType.id === TRANSACTION_TYPES.RECEIVED_VENDOR_INVOICE_ID ? { vendorInvoice } : {}),
    ...(transactionType.id === TRANSACTION_TYPES.ISSUED_CLIENT_INVOICE_ID ? { clientInvoice } : {}),
  };
};
